import { xget, xhttp } from "../Fetchv2";
import { PGSchema } from "../schemas/pg.schema";

export class AssessmentsFolders {
	async getFolders(pgid: string, token: string) {
		const tsup = await xget<{ folders: PGSchema.tests_folders[] }>(`/pages/${pgid}/folders`, { token });
		return tsup;
	}
	async createFolder(params: { pgid: string; name: PGSchema.tests_folders["name"]; token: string }) {
		const tsup = await xhttp<{ data: { id: number } }>(`/pages/${params.pgid}/folders`, "POST", { token: params.token, name: params.name });
		return tsup;
	}

	async editFolder(params: { pgid: string; fid?: PGSchema.tests_folders["id"]; name?: string; parent?: PGSchema.tests_folders["parent"]; token: string }) {
		const tsup = await xhttp<{}>(`/pages/${params.pgid}/folders/${params.fid}`, "PUT", { token: params.token, name: params.name, parent: params.parent });
		return tsup;
	}

	async deleteFolder(params: { pgid: string; fid: PGSchema.tests_folders["id"]; token: string }) {
		const tsup = await xhttp<{}>(`/pages/${params.pgid}/folders/${params.fid}`, "DELETE", { token: params.token });
		return tsup;
	}
}
